import React from 'react'
import { Switch } from 'react-router-dom'
import { Route } from './route'

import { DashboardExternal, DashboardInternal, MultiClient } from '../pages/dashboard'
import { Login } from '../pages/login'
import { NotFound } from '../pages/notfound'
// import { DataCenter, Machine } from '../pages/datacenter'
import { SoftwareManager, SoftwareVersion, CreateSoftwareVersion } from '../pages/software-manager'
import { Ltsp101Catalog } from '../pages/ltsp101-catalog'
import { AdminPage } from '../pages/admin'
import { MobileAppsPage } from '../pages/mobile-apps'
import { UsbFlashArtifactsPage } from '../pages/usb-flash-artifacts'
import { UsersManagementPage } from '../pages/users-management'
import { ConnectedDevicesPage } from '../pages/connected-devices'
import { LicenseKeyManagerPage } from '../pages/license-key-manager'
import { RolesPermissionsPage } from '../pages/roles-permissions'

import { ClientLoader } from '../pages/dashboard/client-loader'

const Routes: React.FC<{}> = () => {
    return (
        <Switch>
            <Route exact path="/login" guest component={Login} />
            <Route auth exact path="/" component={DashboardInternal} permission="page.dashboard_internal" />
            <Route auth exact path="/ext" component={DashboardExternal} permission="page.dashboard_external" />
            <Route auth exact path="/client/:clientId" component={ClientLoader} permission="page.dashboard_internal" />
            <Route auth exact path="/multiclient/:clientIds" component={MultiClient} permission="page.dashboard_internal" />
            {/* <Route auth exact path="/datacenter" component={DataCenter} /> */}
            {/* <Route auth exact path="/datacenter/:machineId" component={Machine} /> */}
            <Route auth exact path="/software-manager" component={SoftwareManager} permission="page.software_manager" />
            <Route auth exact path="/software-manager/new" component={CreateSoftwareVersion} permission="page.software_manager" />
            <Route auth exact path="/software-manager/:softwareVersionId" component={SoftwareVersion} permission="page.software_manager" />
            <Route auth exact path="/ltsp101-catalog" component={Ltsp101Catalog} permission="page.ltsp101_catalog" />
            <Route auth exact path="/mobile-apps" component={MobileAppsPage} permission="page.mobile_apps" />
            <Route auth exact path="/usb-flash-artifacts" component={UsbFlashArtifactsPage} permission="page.usb_flash_artifacts" />
            <Route auth exact path="/admin" component={AdminPage} permission="page.admin" />
            <Route auth exact path="/license-key-manager" component={LicenseKeyManagerPage} permission="page.admin" />
            <Route auth exact path="/users-management" component={UsersManagementPage} permission="page.users_management" />
            <Route auth exact path="/roles-permissions" component={RolesPermissionsPage} permission="page.roles_permissions" />
            <Route auth exact path="/connected-devices" component={ConnectedDevicesPage} permission="page.connected_devices" />
            <Route path="*" component={NotFound} />
        </Switch>
    )
}

export default Routes
